import React, {
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { observer } from 'mobx-react';

import ExternalCoachContext from '../../../../context/ExternalCoachContext';
import { usePodFilter } from '../../../../../context/PodContext';
import OnHoldWorkoutReview from '../../../../Model/OnHoldWorkoutReview';
import OnHoldWorkoutCard from './OnHoldWorkoutCard';
import {
  Wrapper,
  Header,
  HeaderSubtitle,
  StateMessage,
} from './styles';
import texts from './texts.json';

const WorkoutConflictReviewFeed = () => {
  const { externalCoachDoc } = useContext(ExternalCoachContext);
  const coachId = externalCoachDoc?.id;
  const [loading, setLoading] = useState(true);
  const { getFilteredDocs } = usePodFilter();

  const onHoldCollection = useMemo(
    () => (coachId ? OnHoldWorkoutReview.getPendingForCoach(coachId) : null),
    [coachId],
  );

  useEffect(() => {
    let cancelled = false;
    if (!onHoldCollection) {
      setLoading(false);
      return undefined;
    }
    setLoading(true);
    onHoldCollection.fetch().finally(() => {
      if (!cancelled) setLoading(false);
    });
    return () => {
      cancelled = true;
      onHoldCollection.stop?.();
    };
  }, [onHoldCollection]);

  if (!coachId || loading) {
    return (
      <Wrapper>
        <Header>{texts.headerTitle}</Header>
        <StateMessage>{texts.loading}</StateMessage>
      </Wrapper>
    );
  }

  const onHoldItems = getFilteredDocs(onHoldCollection?.docs ?? [], 'user');

  return (
    <Wrapper>
      <Header>{texts.headerTitle}</Header>
      <HeaderSubtitle>{texts.headerSubtitle}</HeaderSubtitle>
      {
        onHoldItems.length === 0
          ? <StateMessage>{texts.emptyState}</StateMessage>
          : onHoldItems.map((onHold) => (
            <OnHoldWorkoutCard key={onHold.id} onHoldWorkoutReview={onHold} />
          ))
      }
    </Wrapper>
  );
};

export default observer(WorkoutConflictReviewFeed);
